import { render, staticRenderFns } from "./NoDataComponent.vue?vue&type=template&id=2e7846a8&scoped=true"
import script from "./NoDataComponent.vue?vue&type=script&lang=js"
export * from "./NoDataComponent.vue?vue&type=script&lang=js"
import style0 from "./NoDataComponent.vue?vue&type=style&index=0&id=2e7846a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7846a8",
  null
  
)

export default component.exports